import { useState, useEffect, useMemo } from 'react';
import { Link } from "react-router-dom";
import Sidebar from '../Sidebar'
import Header from '../Header'
import HeaderFilters from '../HeaderFilters';

import { GiPoliceOfficerHead } from "react-icons/gi";
import { MdCheck, MdLock, MdWhatsapp  } from "react-icons/md";

import { API_BASE } from '../../config/api';

function HomeAdmin() {

const [admin, setAdmin] = useState(null);
const [loadingAdmin, setLoadingAdmin] = useState(true);

useEffect(() => {
    const fetchAdmin = async () => {
        try {
            setLoadingAdmin(true);

            const res = await fetch(`${API_BASE}/api/admin/me`, {
                method: "GET",
                credentials: "include",
            });

            const data = await res.json();

            if (!res.ok || !data.ok) {
                throw new Error(data.message || "No se pudo obtener la información del admin");
            }

            setAdmin(data.data);
        } catch (error) {
            console.error("Error al obtener admin:", error);
            setAdmin(null);
        } finally {
            setLoadingAdmin(false);
        }
    };

    fetchAdmin();
}, []);

const [busquedaUsuario, setBusquedaUsuario] = useState("");
const [usuariosEncontrados, setUsuariosEncontrados] = useState([]);
const [usuarioQuick, setUsuarioQuick] = useState(null);

const [loadingBusqueda, setLoadingBusqueda] = useState(false);
const [loadingDetalle, setLoadingDetalle] = useState(false);

const [errorUsuarioQuick, setErrorUsuarioQuick] = useState("");

const formatNumber = (value) => {
    return Number(value || 0).toLocaleString("es-MX");
};

const formatFechaLogin = (fecha) => {
    if (!fecha) return "Sin registro";

    const date = new Date(String(fecha).replace(" ", "T"));

    if (Number.isNaN(date.getTime())) {
        return "Sin registro";
    }

    return date.toLocaleDateString("es-MX", {
        day: "numeric",
        month: "long",
    });
};

const getPlanMedal = (planNombre) => {
    const plan = String(planNombre || "").toLowerCase();

    if (plan.includes("bronce")) return "🥉";
    if (plan.includes("plata")) return "🥈";
    if (plan.includes("oro")) return "🥇";

    return "🏅";
};

const getWhatsAppLink = (whatsapp) => {
    let clean = String(whatsapp || "").replace(/\D/g, "");

    if (!clean) return null;

    // Si viene con 10 dígitos de México, agrega lada 52
    if (clean.length === 10) {
        clean = `52${clean}`;
    }

    return `https://wa.me/${clean}`;
};

const getEstadoBadgeClass = (estadoDetalle) => {
    return estadoDetalle?.badge_class || "bg-secondary-subtle text-secondary";
};

const handleBuscarUsuarios = async () => {
    try {
        const q = busquedaUsuario.trim();

        if (!q) {
            setErrorUsuarioQuick("Introduce un nombre, apellido, usuario o correo.");
            setUsuariosEncontrados([]);
            setUsuarioQuick(null);
            return;
        }

        if (q.length < 2) {
            setErrorUsuarioQuick("La búsqueda debe tener al menos 2 caracteres.");
            setUsuariosEncontrados([]);
            setUsuarioQuick(null);
            return;
        }

        setLoadingBusqueda(true);
        setErrorUsuarioQuick("");
        setUsuariosEncontrados([]);
        setUsuarioQuick(null);

        const res = await fetch(
            `${API_BASE}/api/admin/admin/user-quick/search?q=${encodeURIComponent(q)}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const data = await res.json();

        if (!res.ok || !data.ok) {
            throw new Error(data.message || "No se pudo realizar la búsqueda.");
        }

        if (!data.data || data.data.length === 0) {
            setErrorUsuarioQuick("Usuario no encontrado.");
            return;
        }

        setUsuariosEncontrados(data.data);
    } catch (error) {
        console.error("Error al buscar usuarios:", error);
        setUsuariosEncontrados([]);
        setUsuarioQuick(null);
        setErrorUsuarioQuick(error.message || "Usuario no encontrado.");
    } finally {
        setLoadingBusqueda(false);
    }
};

const handleSeleccionarUsuario = async (usuarioId) => {
    try {
        setLoadingDetalle(true);
        setErrorUsuarioQuick("");
        setUsuarioQuick(null);

        const res = await fetch(
            `${API_BASE}/api/admin/admin/user-quick/${usuarioId}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const data = await res.json();

        if (!res.ok || !data.ok) {
            throw new Error(data.message || "No se pudo cargar el detalle del usuario.");
        }

        setUsuarioQuick(data.data);
    } catch (error) {
        console.error("Error al cargar detalle:", error);
        setUsuarioQuick(null);
        setErrorUsuarioQuick(error.message || "No se pudo cargar el detalle del usuario.");
    } finally {
        setLoadingDetalle(false);
    }
};

const handleLimpiarBusqueda = () => {
    setBusquedaUsuario("");
    setUsuariosEncontrados([]);
    setUsuarioQuick(null);
    setErrorUsuarioQuick("");
};

const handleVolverLista = () => {
    setUsuarioQuick(null);
    setErrorUsuarioQuick("");
};

const userQuickView = useMemo(() => {
    if (!usuarioQuick) return null;

    const nombreCompleto = `${usuarioQuick.usuario?.nombre || ""} ${usuarioQuick.usuario?.apellido || ""}`.trim();

    return {
        usuarioId: usuarioQuick.usuario?.id,

        nombreCompleto: nombreCompleto || "----",
        usuario: usuarioQuick.usuario?.usuario || "----",
        correo: usuarioQuick.usuario?.correo || "----",

        password: usuarioQuick.acceso?.password_cambiada
            ? "----"
            : usuarioQuick.acceso?.password_temporal || "----",

        ultimoLogin: formatFechaLogin(usuarioQuick.usuario?.ultimo_login),

        planNombre: usuarioQuick.plan?.nombre || "Sin plan",
        gradoNombre: usuarioQuick.grado?.nombre || "Sin grado",
        distyNombre: usuarioQuick.disty?.nombre || "Sin distribuidor",

        estado: usuarioQuick.usuario?.estado || "----",
        estadoDetalle: usuarioQuick.usuario?.estado_detalle || null,

        whatsapp: usuarioQuick.usuario?.whatsapp || "",
        whatsappLink: getWhatsAppLink(usuarioQuick.usuario?.whatsapp),

        passwordCambiada: Boolean(usuarioQuick.acceso?.password_cambiada),

        puntos: usuarioQuick.puntos || {},
        coins: usuarioQuick.coins || {},
    };
}, [usuarioQuick]);



// Panel General
    const [regions, setRegions] = useState([]);
    const [regionId, setRegionId] = useState("");

    const [distys, setDistys] = useState([]);
    const [grados, setGrados] = useState([]);

    const [distyId, setDistyId] = useState("");
    const [gradoId, setGradoId] = useState("");
    const [startDate, setStartDate] = useState("2026-05-11");
    const [endDate, setEndDate] = useState("2026-11-30");

    const [summary, setSummary] = useState({
        usuariosRegistrados: 0,
        usuariosActivos: 0,
        usuariosNoActivos: 0,
        usuariosBorrados: 0,
        usuariosParticipantes: 0,
        usuariosNoParticipantes: 0,
        usuariosLogins: 0,
        usuariosMexico: 0,
        usuariosLatam: 0,
    });

    const [topSesiones, setTopSesiones] = useState([]);
    const [topComentarios, setTopComentarios] = useState([]);

    const [expandedComments, setExpandedComments] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const defaultInstructorImage = "/assets/images/icons/05.png";
    const defaultUserImage = "/assets/images/avatars/01.png";

    const selectedRegionName =
    regions.find((region) => String(region.Region_ID) === String(regionId))?.Region_Nombre || "General";

    const getPercent = (value, total) => {
        if (!total || Number(total) <= 0) return "0%";
        return `${((Number(value) / Number(total)) * 100).toFixed(1)}%`;
    };

    const totalRegistrados = Number(summary.usuariosRegistrados || 0);
    const totalActivos = Number(summary.usuariosActivos || 0);
    const totalLogins = Number(summary.usuariosLogins || 0);

    const pctActivos = getPercent(summary.usuariosActivos, totalRegistrados);
    const pctNoActivos = getPercent(summary.usuariosNoActivos, totalRegistrados);
    const pctBorrados = getPercent(summary.usuariosBorrados, totalRegistrados + Number(summary.usuariosBorrados || 0));

    const pctParticipantes = getPercent(summary.usuariosParticipantes, totalActivos);
    const pctNoParticipantes = getPercent(summary.usuariosNoParticipantes, totalActivos);

    const pctLogins = totalRegistrados > 0
        ? Math.min(100, (totalLogins / totalRegistrados) * 100)
        : 0;

    const handleRegionChange = async (value) => {
        setRegionId(value);
        setDistyId("");
        setGradoId("");

        await getFilters({
            nextRegionId: value,
            nextDistyId: "",
        });
    };

    const handleDistyChange = async (value) => {
        setDistyId(value);
        setGradoId("");

        await getFilters({
            nextRegionId: regionId,
            nextDistyId: value,
        });
    };

    const handleGradoChange = (value) => {
        setGradoId(value);
    };

    const formatDateLabel = (dateValue) => {
        if (!dateValue) return "";

        const date = new Date(dateValue);

        if (Number.isNaN(date.getTime())) return "";

        return date.toLocaleDateString("es-MX", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const toggleComment = (comentarioId) => {
        setExpandedComments((prev) => ({
            ...prev,
            [comentarioId]: !prev[comentarioId],
        }));
    };

    // =============================
    // Cargar filtros iniciales
    // =============================
    const getFilters = async ({ nextRegionId = "", nextDistyId = "" } = {}) => {
        try {
            const params = new URLSearchParams();

            if (nextRegionId) params.append("regionId", nextRegionId);
            if (nextDistyId) params.append("distyId", nextDistyId);

            const response = await fetch(
                `${API_BASE}/api/admin/dashboard/filters?${params.toString()}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result.message || "Error al obtener filtros.");
            }

            setRegions(result.data?.regions || []);
            setDistys(result.data?.distys || []);
            setGrados(result.data?.grados || []);

            return result.data;
        } catch (error) {
            console.error("Error filtros HomeAdmin:", error);
            setError(error.message);
            return null;
        }
    };

    useEffect(() => {
    const initFilters = async () => {
        const data = await getFilters();

        setRegionId("");
        setDistyId("");
        setGradoId("");
        setStartDate(data?.defaultStartDate || "2026-05-11");
        setEndDate(data?.defaultEndDate || "2026-11-30");
    };

    initFilters();
}, []);

    // =============================
    // Cargar dashboard admin
    // =============================
    useEffect(() => {
        const getDashboardData = async () => {
            try {
                setLoading(true);
                setError("");

                const params = new URLSearchParams();

                if (regionId) params.append("regionId", regionId);
                if (distyId) params.append("distyId", distyId);
                if (gradoId) params.append("gradoId", gradoId);
                if (startDate) params.append("startDate", startDate);
                if (endDate) params.append("endDate", endDate);

                const queryString = params.toString();

                const [
                    summaryResponse,
                    topSesionesResponse,
                    topComentariosResponse,
                ] = await Promise.all([
                    fetch(`${API_BASE}/api/admin/dashboard/admin-summary?${queryString}`, {
                        method: "GET",
                        credentials: "include",
                    }),
                    fetch(`${API_BASE}/api/admin/dashboard/admin-top-sesiones?${queryString}`, {
                        method: "GET",
                        credentials: "include",
                    }),
                    fetch(`${API_BASE}/api/admin/dashboard/admin-top-comentarios?${queryString}`, {
                        method: "GET",
                        credentials: "include",
                    }),
                ]);

                const summaryResult = await summaryResponse.json();
                const topSesionesResult = await topSesionesResponse.json();
                const topComentariosResult = await topComentariosResponse.json();

                if (!summaryResponse.ok || !summaryResult.success) {
                    throw new Error(summaryResult.message || "Error al obtener resumen admin.");
                }

                if (!topSesionesResponse.ok || !topSesionesResult.success) {
                    throw new Error(topSesionesResult.message || "Error al obtener top sesiones.");
                }

                if (!topComentariosResponse.ok || !topComentariosResult.success) {
                    throw new Error(topComentariosResult.message || "Error al obtener top comentarios.");
                }

                setSummary(summaryResult.data || {});
                setTopSesiones(
                    Array.isArray(topSesionesResult.data) ? topSesionesResult.data : []
                );

                setTopComentarios(
                    Array.isArray(topComentariosResult.data) ? topComentariosResult.data : []
                );
                setExpandedComments({});
            } catch (error) {
                console.error("Error dashboard HomeAdmin:", error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        getDashboardData();
    }, [regionId, distyId, gradoId, startDate, endDate]);


  return (
    <>
    <Sidebar/>
    <main class="main-content">
        <Header/>

        <div class="content-inner container-fluid pb-0" id="page_layout">
            
            <HeaderFilters
                title="Datos Básicos"
                subtitle="Panel Administrador"

                regions={regions}
                distys={distys}
                grados={grados}

                regionId={regionId}
                distyId={distyId}
                gradoId={gradoId}

                startDate={startDate}
                endDate={endDate}

                onRegionChange={handleRegionChange}
                onDistyChange={handleDistyChange}
                onGradoChange={handleGradoChange}
                onStartDateChange={setStartDate}
                onEndDateChange={setEndDate}
            />
            <div className='row'>
                <div class="col-lg-4">
                    {!regionId ? (
    <div className="row g-3 mb-4">
        <div className="col-md-12">
            <div className="card h-100 dashboard-stat-card">
                <div className="card-body">
                    <div className='d-flex justify-content-between align-items-center'>
                    <div class="bg-info text-white rounded p-3">
                        <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                            <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                            <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                            <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                            <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                            <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                        </svg>
                    </div>
                    <div class="text-end">
                    <p className="dashboard-stat-label">Usuarios registrados</p>
                    <h3 className="dashboard-stat-value">
                        {Number(summary.usuariosRegistrados || 0).toLocaleString("es-MX")}
                    </h3>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="col-md-6">
            <div className="card h-100 dashboard-stat-card">
                <div className="card-body">
                    <div className='d-flex justify-content-between align-items-center'>
                    <div class="bg-info text-white rounded p-3">
                        <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                            <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                            <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                            <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                            <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                            <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                        </svg>
                    </div>
                    <div class="text-end">
                    <p className="dashboard-stat-label">Usuarios México</p>
                    <h3 className="dashboard-stat-value">
                        {Number(summary.usuariosMexico || 0).toLocaleString("es-MX")}
                    </h3>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="col-md-6">
            <div className="card h-100 dashboard-stat-card">
                <div className="card-body">
                    <div className='d-flex justify-content-between align-items-center'>
                    <div class="bg-info text-white rounded p-3">
                        <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                            <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                            <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                            <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                            <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                            <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                        </svg>
                    </div>
                    <div class="text-end">
                    <p className="dashboard-stat-label">Usuarios Latam</p>
                    <h3 className="dashboard-stat-value">
                        {Number(summary.usuariosLatam || 0).toLocaleString("es-MX")}
                    </h3>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="col-md-4">
            <div className="card h-100 dashboard-stat-card">
                <div className="card-body">
                    <div className="dashboard-stat-icon text-success">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                            <path d="M20 7L9 18L4 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <p className="dashboard-stat-label">Usuarios activos</p>
                    <h3 className="dashboard-stat-value">
                        {Number(summary.usuariosActivos || 0).toLocaleString("es-MX")}
                    </h3>
                </div>
            </div>
        </div>

        <div className="col-md-4">
            <div className="card h-100 dashboard-stat-card">
                <div className="card-body">
                    <div className="dashboard-stat-icon text-warning">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                            <path d="M12 8V12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                            <circle cx="12" cy="16" r="1" fill="currentColor"/>
                            <path d="M10.29 3.86L1.82 18A2 2 0 0 0 3.53 21H20.47A2 2 0 0 0 22.18 18L13.71 3.86A2 2 0 0 0 10.29 3.86Z" stroke="currentColor" strokeWidth="1.5"/>
                        </svg>
                    </div>
                    <p className="dashboard-stat-label">Usuarios no activos</p>
                    <h3 className="dashboard-stat-value">
                        {Number(summary.usuariosNoActivos || 0).toLocaleString("es-MX")}
                    </h3>
                </div>
            </div>
        </div>

        <div className="col-md-4">
            <div className="card h-100 dashboard-stat-card">
                <div className="card-body">
                    <div className="dashboard-stat-icon text-danger">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                            <path d="M6 6L18 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <p className="dashboard-stat-label">Usuarios borrados</p>
                    <h3 className="dashboard-stat-value">
                        {Number(summary.usuariosBorrados || 0).toLocaleString("es-MX")}
                    </h3>
                </div>
            </div>
        </div>

        
    </div>
) : (
    <div className="row mb-4">
    <div className="col-lg-12">
        <div className="card">
            <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                    <div>
                        <h4 className="mb-1">Usuarios {selectedRegionName}</h4>
                        <small className="text-muted">
                            Registrados: {Number(summary.usuariosRegistrados || 0).toLocaleString("es-MX")}
                        </small>
                    </div>
                </div>

                {/* Fila 1 */}
                <div className="row g-3 mb-3">
                    <div className="col-md-4">
                        <div className="border rounded p-3 h-100 regional-metric-card">
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <div className="regional-metric-icon text-success">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <path d="M20 7L9 18L4 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <small className="text-muted mb-0">Usuarios activos</small>
                            </div>

                            <h2 className="mb-1">
                                {Number(summary.usuariosActivos || 0).toLocaleString("es-MX")}
                            </h2>

                            <small className="text-success fw-semibold">
                                {pctActivos}
                            </small>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="border rounded p-3 h-100 regional-metric-card">
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <div className="regional-metric-icon text-warning">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 8V12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                                        <circle cx="12" cy="16" r="1" fill="currentColor"/>
                                        <path d="M10.29 3.86L1.82 18A2 2 0 0 0 3.53 21H20.47A2 2 0 0 0 22.18 18L13.71 3.86A2 2 0 0 0 10.29 3.86Z" stroke="currentColor" strokeWidth="1.5"/>
                                    </svg>
                                </div>
                                <small className="text-muted mb-0">Usuarios no activos</small>
                            </div>

                            <h2 className="mb-1">
                                {Number(summary.usuariosNoActivos || 0).toLocaleString("es-MX")}
                            </h2>

                            <small className="text-warning fw-semibold">
                                {pctNoActivos}
                            </small>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="border rounded p-3 h-100 regional-metric-card">
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <div className="regional-metric-icon text-danger">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                                        <path d="M6 6L18 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                                    </svg>
                                </div>
                                <small className="text-muted mb-0">Usuarios borrados</small>
                            </div>

                            <h2 className="mb-1">
                                {Number(summary.usuariosBorrados || 0).toLocaleString("es-MX")}
                            </h2>

                            <small className="text-danger fw-semibold">
                                {pctBorrados}
                            </small>
                        </div>
                    </div>
                </div>

                {/* Fila 2 */}
                <div className="row g-3 mb-4">
                    <div className="col-md-6">
                        <div className="border rounded p-3 h-100 regional-metric-card">
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="regional-metric-icon text-primary">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 20V10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                                            <path d="M7 15L12 20L17 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div>
                                    <small className="text-muted mb-0">Participantes</small>
                                </div>

                                <span className="badge bg-primary">
                                    {pctParticipantes}
                                </span>
                            </div>

                            <h2 className="mb-0">
                                {Number(summary.usuariosParticipantes || 0).toLocaleString("es-MX")}
                            </h2>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="border rounded p-3 h-100 regional-metric-card">
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="regional-metric-icon text-dark">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 4V14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                                            <path d="M17 9L12 4L7 9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div>
                                    <small className="text-muted mb-0">No participantes</small>
                                </div>

                                <span className="badge bg-dark">
                                    {pctNoParticipantes}
                                </span>
                            </div>

                            <h2 className="mb-0">
                                {Number(summary.usuariosNoParticipantes || 0).toLocaleString("es-MX")}
                            </h2>
                        </div>
                    </div>
                </div>

                {/* Progress bar */}
                <div className="border rounded p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                        <div>
                            <h6 className="mb-0">Registros vs Logins</h6>
                            <small className="text-muted">
                                {Number(summary.usuariosLogins || 0).toLocaleString("es-MX")} de{" "}
                                {Number(summary.usuariosRegistrados || 0).toLocaleString("es-MX")} usuarios registrados han iniciado sesión.
                            </small>
                        </div>

                        <span className="fw-bold text-primary">
                            {pctLogins.toFixed(1)}%
                        </span>
                    </div>

                    <div className="progress" style={{ height: "10px" }}>
                        <div
                            className="progress-bar bg-primary"
                            role="progressbar"
                            style={{ width: `${pctLogins}%` }}
                            aria-valuenow={pctLogins}
                            aria-valuemin="0"
                            aria-valuemax="100"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
)}
                </div>

                 <div className="col-lg-4">
                        <div className="card">
                            <div className="card-header">
                                <div className="header-title">
                                    <h4 className="card-title">Top Sesiones</h4>
                                </div>
                            </div>

                            <div
                                className="card-body"
                                style={{
                                    maxHeight: "430px",
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                }}
                            >
                                {!Array.isArray(topSesiones) || topSesiones.length === 0 ? (
                                    <p className="text-muted mb-0">
                                        No hay sesiones completadas.
                                    </p>
                                ) : (
                                    <ul className="list-inline m-0 p-0">
                                        {topSesiones.map((sesion) => (
                                            <li
                                                className="d-flex mb-4 align-items-center"
                                                key={sesion.videoId}
                                            >
                                                <div className="img-fluid bg-warning-subtle rounded-pill">
                                                    <img
                                                        src={sesion.instructor?.foto || defaultInstructorImage}
                                                        alt={sesion.instructor?.nombre || "imagen del instructor"}
                                                        className="rounded-pill avatar-40"
                                                        loading="lazy"
                                                        onError={(e) => {
                                                            e.currentTarget.src = defaultInstructorImage;
                                                        }}
                                                    />
                                                </div>

                                                <div
                                                    className="ms-3 flex-grow-1"
                                                    style={{ marginBottom: "0px" }}
                                                >
                                                    <h6 className="mb-1">
                                                        {sesion.videoTitulo || "Sin título"}
                                                    </h6>

                                                    <small>
                                                        {sesion.instructor?.nombre || "Sin instructor"}
                                                    </small>
                                                </div>

                                                <p className="mb-0 text-end">
                                                    <strong>
                                                        {Number(sesion.totalCompletados || 0).toLocaleString("es-MX")}
                                                    </strong>
                                                    <br />
                                                    <small>Completadas</small>
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>

                <div className="col-lg-4">
                        <div className="card">
                            <div className="card-header">
                                <div className="header-title">
                                    <h4 className="card-title">Top Comentarios</h4>
                                </div>
                            </div>

                            <div
                                className="card-body"
                                style={{
                                    maxHeight: "430px",
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                }}
                            >
                                {!Array.isArray(topComentarios) || topComentarios.length === 0 ? (
                                    <p className="text-muted mb-0">
                                        No hay comentarios con respuestas.
                                    </p>
                                ) : (
                                    topComentarios.map((comentario) => {
                                        const isExpanded = Boolean(
                                            expandedComments[comentario.comentarioId]
                                        );

                                        const nombreCompleto = `${comentario.usuario?.nombre || ""} ${comentario.usuario?.apellido || ""}`.trim();

                                        return (
                                            <div key={comentario.comentarioId}>
                                                <div className="twit-feed">
                                                    <div className="d-flex align-items-center mb-4">
                                                        <img
                                                            src={comentario.usuario?.foto || defaultUserImage}
                                                            alt={nombreCompleto || "User-Profile"}
                                                            className="theme-color-default-img img-fluid avatar-60 me-3 rounded-pill"
                                                            loading="lazy"
                                                            onError={(e) => {
                                                                e.currentTarget.src = defaultUserImage;
                                                            }}
                                                        />

                                                        <div className="media-support-info">
                                                            <h6 className="mb-0">
                                                                {nombreCompleto || "Usuario sin nombre"}
                                                            </h6>

                                                            <p className="mb-0">
                                                                @{comentario.usuario?.usuario || "usuario"}
                                                            </p>

                                                            {comentario.videoTitulo && (
                                                                <small className="text-primary">
                                                                    {comentario.videoTitulo}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="media-support-body">
                                                        <p className="mb-2">
                                                            {comentario.comentarioTexto}
                                                        </p>

                                                        <div className="twit-date mb-3">
                                                            {formatDateLabel(comentario.comentarioAct)}
                                                        </div>

                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="badge bg-primary-subtle text-primary">
                                                                {Number(comentario.totalRespuestas || 0)} respuestas
                                                            </span>

                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-primary rounded-pill px-3"
                                                                onClick={() => toggleComment(comentario.comentarioId)}
                                                            >
                                                                {isExpanded ? "Mostrar menos" : "Mostrar más"}
                                                            </button>
                                                        </div>

                                                        {isExpanded && (
                                                            <div className="mt-3 ps-3 border-start">
                                                                {comentario.respuestas?.length > 0 ? (
                                                                    comentario.respuestas.map((respuesta) => (
                                                                        <div
                                                                            className="mb-3 p-3 rounded"
                                                                            key={respuesta.respuestaComentarioId}
                                                                        >
                                                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                                                <h6 className="mb-0">
                                                                                    {respuesta.autorNombre || "Respuesta"}
                                                                                </h6>

                                                                                <span className="badge bg-secondary-subtle text-secondary">
                                                                                    {respuesta.autorTipo}
                                                                                </span>
                                                                            </div>

                                                                            <p className="mb-1">
                                                                                {respuesta.respuestaTexto}
                                                                            </p>

                                                                            <small className="text-muted">
                                                                                {formatDateLabel(respuesta.respuestaAct)}
                                                                            </small>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <p className="text-muted mb-0">
                                                                        Este comentario no tiene respuestas disponibles.
                                                                    </p>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <hr className="my-4" />
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>
                </div>
            </div>

            <div className='row'>
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-header">
                            <div className="d-flex align-items-center">
                                <div>
                                    <GiPoliceOfficerHead
                                        className="mr-5"
                                        size="28px"
                                        color="black"
                                    />
                                </div>

                                <h4 className="me-3 mb-0">
                                    Búsqueda rápida de Usuario
                                </h4>
                            </div>
                        </div>

                        <div className="card-body user-quick-card-body">
                            <div className="d-flex mb-3 pb-3 border-bottom gap-3">
                                <div className="flex-grow-1">
                                    <div className="form-group input-group mb-0 search-input">
                                        <span className="input-group-text">
                                            <svg
                                                className="icon-20"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <circle
                                                    cx="11.7669"
                                                    cy="11.7666"
                                                    r="8.98856"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M18.0186 18.4851L21.5426 22"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>

                                        <input
                                            className="form-control"
                                            placeholder="Nombre, apellido, usuario o correo"
                                            type="text"
                                            value={busquedaUsuario}
                                            onChange={(e) => setBusquedaUsuario(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleBuscarUsuarios();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    onClick={handleBuscarUsuarios}
                                    disabled={loadingBusqueda}
                                >
                                    {loadingBusqueda ? "Buscando..." : "Buscar"}
                                </button>
                            </div>

                            <div className="user-quick-scroll-area">
                                {errorUsuarioQuick && (
                                    <div className="alert alert-danger d-flex align-items-center" role="alert">
                                        <svg
                                            width="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                opacity="0.4"
                                                d="M4.72251 21.1672C4.70951 21.1672 4.69751 21.1672 4.68351 21.1662C4.36851 21.1502 4.05951 21.0822 3.76551 20.9632C2.31851 20.3752 1.62051 18.7222 2.20751 17.2762L9.52851 4.45025C9.78051 3.99425 10.1625 3.61225 10.6285 3.35425C11.9935 2.59825 13.7195 3.09525 14.4745 4.45925L21.7475 17.1872C21.9095 17.5682 21.9785 17.8782 21.9955 18.1942C22.0345 18.9502 21.7765 19.6752 21.2705 20.2362C20.7645 20.7972 20.0695 21.1282 19.3145 21.1662L4.79451 21.1672H4.72251Z"
                                                fill="currentColor"
                                            />
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M11.1245 10.0208C11.1245 9.53875 11.5175 9.14575 11.9995 9.14575C12.4815 9.14575 12.8745 9.53875 12.8745 10.0208V12.8488C12.8745 13.3318 12.4815 13.7238 11.9995 13.7238C11.5175 13.7238 11.1245 13.3318 11.1245 12.8488V10.0208ZM11.1245 16.2699C11.1245 15.7849 11.5175 15.3899 11.9995 15.3899C12.4815 15.3899 12.8745 15.7799 12.8745 16.2589C12.8745 16.7519 12.4815 17.1449 11.9995 17.1449C11.5175 17.1449 11.1245 16.7519 11.1245 16.2699Z"
                                                fill="currentColor"
                                            />
                                        </svg>

                                        <div className="ml-5">
                                            {errorUsuarioQuick}
                                        </div>
                                    </div>
                                )}

                                {usuariosEncontrados.length > 0 && !userQuickView && (
                                    <div className="mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <small className="text-muted">
                                                Selecciona un usuario:
                                            </small>

                                            <button
                                                type="button"
                                                className="btn btn-link btn-sm p-0"
                                                onClick={handleLimpiarBusqueda}
                                            >
                                                Limpiar
                                            </button>
                                        </div>

                                        <div className="list-group">
                                            {usuariosEncontrados.map((item) => (
                                                <button
                                                    key={item.id}
                                                    type="button"
                                                    className="list-group-item list-group-item-action"
                                                    onClick={() => handleSeleccionarUsuario(item.id)}
                                                    disabled={loadingDetalle}
                                                >
                                                    <div className="d-flex justify-content-between align-items-start gap-3">
                                                        <div>
                                                            <h6 className="mb-1">
                                                                {item.nombre_completo || "Sin nombre"}
                                                            </h6>

                                                            <small className="text-muted d-block">
                                                                {item.correo || "Sin correo"}
                                                            </small>

                                                            <small className="text-muted d-block">
                                                                Usuario: {item.usuario || "----"}
                                                            </small>

                                                            <small className="text-muted d-block">
                                                                Disty: {item.disty_nombre || "Sin distribuidor"}
                                                            </small>
                                                        </div>

                                                        <div className="text-end">
                                                            <span className="badge bg-light-subtle text-dark mb-1">
                                                                {getPlanMedal(item.plan_nombre)}{" "}
                                                                {item.plan_nombre || "Sin plan"}
                                                            </span>

                                                            <br />

                                                            <span className="badge bg-primary mb-1">
                                                                {item.grado_nombre || "Sin grado"}
                                                            </span>

                                                            <br />

                                                            <span
                                                                className={`badge ${getEstadoBadgeClass(item.estado_detalle)}`}
                                                            >
                                                                {item.estado || "----"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {loadingDetalle && (
                                    <div className="text-center py-3">
                                        Cargando detalle...
                                    </div>
                                )}

                                {userQuickView && (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <small className="text-muted">
                                                Detalle del usuario
                                            </small>

                                            {usuariosEncontrados.length > 0 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-link btn-sm p-0"
                                                    onClick={handleVolverLista}
                                                >
                                                    Ver lista
                                                </button>
                                            )}
                                        </div>

                                        <div className="d-flex mb-3 gap-3">
                                            <div className="align-items-center gap-2">
                                                <small className="mb-0">NOMBRE:</small>
                                                <h6 className="mb-1">
                                                    {userQuickView.nombreCompleto}
                                                </h6>

                                                <small className="mb-0">USUARIO:</small>
                                                <h6 className="mb-1">
                                                    {userQuickView.usuario}
                                                </h6>

                                                <small className="mb-0">CORREO:</small>
                                                <h6 className="mb-1">
                                                    {userQuickView.correo}
                                                </h6>

                                                {/* <small className="mb-0">CONTRASEÑA:</small>
                                                <h6 className="mb-1">
                                                    {userQuickView.password}
                                                </h6> */}

                                                <small className="mb-0">ÚLTIMO LOGIN:</small>
                                                <h6 className="mb-1">
                                                    {userQuickView.ultimoLogin}
                                                </h6>
                                            </div>
                                        </div>

                                        <div className="d-flex mb-3 pb-3 border-bottom gap-3">
                                            <div className="align-items-center gap-2">
                                                <span className="badge bg-light-subtle text-dark p-2 mb-3 mr-5">
                                                    {getPlanMedal(userQuickView.planNombre)}{" "}
                                                    {userQuickView.planNombre} - {userQuickView.gradoNombre}
                                                </span>

                                                <span className="badge bg-primary p-2 mb-3 mr-5">
                                                    {userQuickView.distyNombre}
                                                </span>

                                                <span
                                                    className={`badge p-2 mb-3 mr-5 ${getEstadoBadgeClass(userQuickView.estadoDetalle)}`}
                                                >
                                                    {userQuickView.estado}
                                                </span>

                                                {userQuickView.passwordCambiada ? (
                                                    <span className="badge bg-warning-subtle p-2 mb-3 mr-5 text-warning">
                                                        <MdLock />{" "}
                                                        Contraseña Cambiada
                                                    </span>
                                                ) : (
                                                    <span className="badge bg-success-subtle p-2 mb-3 mr-5 text-success">
                                                        <MdCheck />{" "}
                                                        Contraseña
                                                    </span>
                                                )}

                                                {userQuickView.whatsappLink && (
                                                    <a
                                                        href={userQuickView.whatsappLink}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="badge bg-success-subtle p-2 mb-3 mr-5 text-success text-decoration-none"
                                                    >
                                                        <MdWhatsapp />{" "}
                                                        WhatsApp
                                                    </a>
                                                )}
                                            </div>
                                        </div>

                                        <div className="d-flex mb-3 pb-3 border-bottom gap-3">
                                            <div className="align-items-center gap-2 w-100">
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-6 mb-3">
                                                        <div className="card bg-light-subtle mb-0">
                                                            <div className="card-body p-3">
                                                                <small className="text-muted">
                                                                    PUNTOS
                                                                </small>

                                                                <h4 className="mb-1">
                                                                    {formatNumber(userQuickView.puntos.total)}
                                                                </h4>

                                                                <div className="d-flex justify-content-between">
                                                                    <small>Ganados:</small>
                                                                    <small>
                                                                        {formatNumber(userQuickView.puntos.ganados)}
                                                                    </small>
                                                                </div>

                                                                <div className="d-flex justify-content-between">
                                                                    <small>Usados:</small>
                                                                    <small>
                                                                        {formatNumber(userQuickView.puntos.usados)}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-6 mb-3">
                                                        <div className="card bg-light-subtle mb-0">
                                                            <div className="card-body p-3">
                                                                <small className="text-muted">
                                                                    COINS
                                                                </small>

                                                                <h4 className="mb-1">
                                                                    {formatNumber(userQuickView.coins.total)}
                                                                </h4>

                                                                <div className="d-flex justify-content-between">
                                                                    <small>Agregados:</small>
                                                                    <small>
                                                                        {formatNumber(userQuickView.coins.agregados)}
                                                                    </small>
                                                                </div>

                                                                <div className="d-flex justify-content-between">
                                                                    <small>Usados:</small>
                                                                    <small>
                                                                        {formatNumber(userQuickView.coins.usados)}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-grid mt-3">
                                            <Link
                                                to={`/usuario-detalle/${userQuickView.usuarioId}`}
                                                className="btn btn-primary"
                                            >
                                                Ver detalle completo
                                            </Link>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </>
  )
}

function DashboardCard({ title, value }) {
    return (
        <div className="col-md-3">
            <div className="card">
                <div className="card-body">
                    <p className="mb-1">{title}</p>
                    <h3 className="mb-0">
                        {Number(value || 0).toLocaleString("es-MX")}
                    </h3>
                </div>
            </div>
        </div>
    );
}

export default HomeAdmin